import { useTranslation } from 'react-i18next';

import TimeDurationLine from '@/assets/icons/time_duration_line.svg?component';
import WifiOffLine from '@/assets/icons/wifi_off_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { ToggleChip } from '@/components/atoms/ToggleChip';

import type { AllButtonState, LocationVideoCage } from '../locationVideoStore';

import { Viewmode } from './VideoBanners';

import styles from '../LocationVideo.module.scss';

interface ChipsButtonsProps {
    cageChangedHandler: (bioscopeId: number) => void;
    allCagesChangedHandler: (buttonState: boolean) => void;
    activeCagesButtons: LocationVideoCage[];
    allButton: AllButtonState;
    onlyViewMode: boolean;
}

/** One chip per pen to start or stop its stream, plus all on and all off. */
export default function ChipsButtons({
    cageChangedHandler,
    allCagesChangedHandler,
    activeCagesButtons,
    allButton,
    onlyViewMode,
}: ChipsButtonsProps) {
    const { t } = useTranslation();

    if (onlyViewMode) {
        return <Viewmode t={t} />;
    }

    return (
        <div className={styles.buttonWrapper}>
            <ToggleChip
                className={styles.chip}
                disabled={allButton.isDisabled}
                onClick={() => allCagesChangedHandler(true)}
                pressed={allButton.isSelected}>
                {t('location.video.allOn')}
            </ToggleChip>
            <ToggleChip
                className={styles.chip}
                disabled={allButton.isDisabled}
                onClick={() => allCagesChangedHandler(false)}>
                {t('location.video.allOff')}
            </ToggleChip>
            {activeCagesButtons?.map((cage) => (
                <ToggleChip
                    key={cage.cageId}
                    className={styles.chip}
                    disabled={cage.isButtonDisabled || cage.isOutOfQuota || cage.isInvalidBioscope}
                    onClick={() => cageChangedHandler(cage.bioscopeId)}
                    pressed={cage.isButtonSelected}>
                    {!cage.online && !cage.isOutOfQuota && (
                        <SvgIcon
                            icon={WifiOffLine}
                            size="custom"
                            customSize={20}
                            color="currentColor"
                        />
                    )}
                    {cage.isOutOfQuota && (
                        <SvgIcon
                            icon={TimeDurationLine}
                            size="custom"
                            customSize={20}
                            color="currentColor"
                        />
                    )}
                    {cage.isInvalidBioscope && (
                        <SvgIcon
                            icon={WifiOffLine}
                            size="custom"
                            customSize={20}
                            color="currentColor"
                        />
                    )}
                    {cage.cageName}
                </ToggleChip>
            ))}
        </div>
    );
}
